(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lucia-bathroom-mist-reveal"] && !Shopify.designMode) return;
  try {
    (()=>{
  const init=root=>{
    if(!root||root.dataset.lbmReady==='true')return;
    root.dataset.lbmReady='true';
    const mirror=root.querySelector('[data-lbm-mirror]'),canvas=root.querySelector('[data-lbm-mist]');
    if(!mirror||!canvas)return;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});
    let active=false,cleared=false,visited=new Set();const cols=20,rows=12;
    const paint=()=>{if(cleared)return;const r=mirror.getBoundingClientRect(),d=Math.min(window.devicePixelRatio||1,2);canvas.width=Math.max(1,Math.round(r.width*d));canvas.height=Math.max(1,Math.round(r.height*d));canvas.style.width=r.width+'px';canvas.style.height=r.height+'px';ctx.setTransform(d,0,0,d,0,0);const g=ctx.createLinearGradient(0,0,r.width,r.height);g.addColorStop(0,'rgba(248,251,248,.96)');g.addColorStop(.48,'rgba(219,227,222,.94)');g.addColorStop(1,'rgba(238,243,240,.92)');ctx.globalCompositeOperation='source-over';ctx.fillStyle=g;ctx.fillRect(0,0,r.width,r.height);visited.clear()};
    const wipe=e=>{if(cleared)return;const r=mirror.getBoundingClientRect(),x=Math.max(0,Math.min(r.width,e.clientX-r.left)),y=Math.max(0,Math.min(r.height,e.clientY-r.top)),radius=Math.max(56,Math.min(150,r.width*.14));ctx.save();ctx.globalCompositeOperation='destination-out';const g=ctx.createRadialGradient(x,y,radius*.2,x,y,radius);g.addColorStop(0,'rgba(0,0,0,1)');g.addColorStop(.72,'rgba(0,0,0,.94)');g.addColorStop(1,'rgba(0,0,0,0)');ctx.fillStyle=g;ctx.beginPath();ctx.arc(x,y,radius,0,Math.PI*2);ctx.fill();ctx.restore();const cx=Math.max(0,Math.min(cols-1,Math.floor(x/r.width*cols))),cy=Math.max(0,Math.min(rows-1,Math.floor(y/r.height*rows))),reach=Math.max(1,Math.round(radius/r.width*cols));for(let ix=Math.max(0,cx-reach);ix<=Math.min(cols-1,cx+reach);ix++)for(let iy=Math.max(0,cy-reach);iy<=Math.min(rows-1,cy+reach);iy++){const dx=(ix+.5)/cols*r.width-x,dy=(iy+.5)/rows*r.height-y;if(dx*dx+dy*dy<radius*radius*.58)visited.add(ix+':'+iy)}if(visited.size/(cols*rows)>=.6){cleared=true;mirror.classList.add('is-cleared');setTimeout(()=>{canvas.width=1;canvas.height=1},900)}};
    mirror.addEventListener('pointerdown',e=>{active=true;mirror.setPointerCapture?.(e.pointerId);wipe(e)});mirror.addEventListener('pointermove',e=>{if(e.pointerType==='mouse'||active)wipe(e)});mirror.addEventListener('pointerup',()=>active=false);mirror.addEventListener('pointercancel',()=>active=false);paint();new ResizeObserver(paint).observe(mirror);
  };
  document.querySelectorAll('[data-lbm-root]').forEach(init);document.addEventListener('shopify:block:load',e=>init(e.target.matches('[data-lbm-root]')?e.target:e.target.querySelector('[data-lbm-root]')));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucia-bedroom-sheer-curtain"] && !Shopify.designMode) return;
  try {
    (() => {
    const globalKey = '__luciaBedroomController';
    if (window[globalKey]) {
      window[globalKey].initWithin(document);
      return;
    }
    const clamp = (value) => Math.max(0,Math.min(1,value));
    const controllers = new WeakMap();
    const init = (root) => {
      if (!root || controllers.has(root)) return;
      const journey = root.querySelector('[data-lbr-journey]');
      if (!journey) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const motionEnabled = root.dataset.lbrMotion !== 'false';
      let rafId = 0;
      const measure = () => {
        const bounds = journey.getBoundingClientRect();
        const range = Math.max(1,journey.offsetHeight - window.innerHeight);
        return reduced || !motionEnabled ? 1 : clamp(-bounds.top / range);
      };
      const update = () => {
        root.style.setProperty('--lbr-progress',measure().toFixed(4));
        rafId = 0;
      };
      const queueUpdate = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(update);
      };
      const initialProgress = measure();
      const draggedAnchors = new WeakSet();
      const pointerStarts = new WeakMap();
      const suppressTimers = new Map();
      const linkedAnchor = (event) => {
        if (!(event.target instanceof Element)) return null;
        const anchor = event.target.closest('a.lbr-corner.is-linked');
        return anchor && root.contains(anchor) ? anchor : null;
      };
      const clearSuppression = (anchor) => {
        const timerId = suppressTimers.get(anchor);
        if (timerId) window.clearTimeout(timerId);
        suppressTimers.delete(anchor);
        draggedAnchors.delete(anchor);
      };
      const onPointerDown = (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const anchor = linkedAnchor(event);
        if (!anchor) return;
        clearSuppression(anchor);
        pointerStarts.set(anchor,{x:event.clientX,y:event.clientY,time:event.timeStamp,id:event.pointerId});
      };
      const onPointerUp = (event) => {
        const anchor = linkedAnchor(event);
        if (!anchor) return;
        const pointerStart = pointerStarts.get(anchor);
        if (!pointerStart || pointerStart.id !== event.pointerId) return;
        const horizontal = Math.abs(event.clientX - pointerStart.x);
        const vertical = Math.abs(event.clientY - pointerStart.y);
        pointerStarts.delete(anchor);
        if (horizontal > 8 && horizontal > vertical) {
          event.preventDefault();
          draggedAnchors.add(anchor);
          suppressTimers.set(anchor,window.setTimeout(() => clearSuppression(anchor),0));
        }
      };
      const onPointerCancel = (event) => {
        const anchor = linkedAnchor(event);
        if (!anchor) return;
        pointerStarts.delete(anchor);
        clearSuppression(anchor);
      };
      const onClick = (event) => {
        const anchor = linkedAnchor(event);
        if (!anchor || !draggedAnchors.has(anchor)) return;
        event.preventDefault();
        event.stopPropagation();
        clearSuppression(anchor);
      };
      root.addEventListener('pointerdown',onPointerDown);
      root.addEventListener('pointerup',onPointerUp);
      root.addEventListener('pointercancel',onPointerCancel);
      root.addEventListener('click',onClick);
      window.addEventListener('scroll',queueUpdate,{passive:true});
      window.addEventListener('resize',queueUpdate);
      root.style.setProperty('--lbr-progress','0');
      root.classList.add('is-ready');
      root.dataset.lbrReady = 'true';
      root.style.setProperty('--lbr-progress',initialProgress.toFixed(4));
      const cleanup = () => {
        window.removeEventListener('scroll',queueUpdate);
        window.removeEventListener('resize',queueUpdate);
        root.removeEventListener('pointerdown',onPointerDown);
        root.removeEventListener('pointerup',onPointerUp);
        root.removeEventListener('pointercancel',onPointerCancel);
        root.removeEventListener('click',onClick);
        if (rafId) cancelAnimationFrame(rafId);
        suppressTimers.forEach((timerId) => window.clearTimeout(timerId));
        suppressTimers.clear();
        root.classList.remove('is-ready');
        delete root.dataset.lbrReady;
        root.style.setProperty('--lbr-progress','1');
        controllers.delete(root);
      };
      controllers.set(root,{cleanup});
    };
    const destroy = (root) => {
      const controller = controllers.get(root);
      if (controller) controller.cleanup();
    };
    const initWithin = (scope) => {
      if (scope.matches && scope.matches('[data-lbr-root]')) init(scope);
      scope.querySelectorAll('[data-lbr-root]').forEach(init);
    };
    const destroyWithin = (scope) => {
      if (scope.matches && scope.matches('[data-lbr-root]')) destroy(scope);
      scope.querySelectorAll('[data-lbr-root]').forEach(destroy);
    };
    window[globalKey] = {initWithin,destroyWithin};
    initWithin(document);
    document.addEventListener('shopify:section:load',(event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload',(event) => destroyWithin(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucia-hallway-timeline"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.lh5Ready === 'true') return;
      root.dataset.lh5Ready = 'true';
      const scenes = [...root.querySelectorAll('[data-lh5-scene]')];
      const triggers = [...root.querySelectorAll('[data-lh5-trigger]')];

      const show = (index) => {
        scenes.forEach((scene) => {
          const active = scene.dataset.lh5Scene === String(index);
          scene.classList.toggle('is-active', active);
          scene.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        triggers.forEach((trigger) => {
          const active = index !== 0 && trigger.dataset.lh5Trigger === String(index);
          trigger.classList.toggle('is-active', active);
          if (trigger.matches('button')) trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      triggers.forEach((trigger) => {
        const index = Number(trigger.dataset.lh5Trigger);
        trigger.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') show(index);
        });
        trigger.addEventListener('focus', () => show(index));
        if (trigger.matches('button')) trigger.addEventListener('click', () => show(index));
      });

      root.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch') show(0);
      });
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) show(0);
      });
      show(0);
    };

    document.querySelectorAll('.lh5-root').forEach(init);
    document.addEventListener('shopify:section:load', () => document.querySelectorAll('.lh5-root').forEach(init));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucia-kid-study-open-book"] && !Shopify.designMode) return;
  try {
    (()=>{const init=root=>{if(!root||root.dataset.lksReady==='true')return;root.dataset.lksReady='true';const journey=root.querySelector('[data-lks-journey]'),book=root.querySelector('[data-lks-book]');if(!journey||!book)return;let ticking=false;const update=()=>{const r=journey.getBoundingClientRect(),range=Math.max(1,journey.offsetHeight-innerHeight),progress=Math.max(0,Math.min(1,-r.top/range)),open=Math.max(0,Math.min(1,progress/.42)),exit=Math.max(0,Math.min(1,(progress-.56)/.18));book.style.setProperty('--lks-open',open.toFixed(3));root.style.setProperty('--lks-header-y',(-exit*150).toFixed(1)+'px');root.style.setProperty('--lks-header-opacity',(1-exit).toFixed(3));root.style.setProperty('--lks-book-y',(-exit*64).toFixed(1)+'px');ticking=false};addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}},{passive:true});update()};document.querySelectorAll('[data-lks-root]').forEach(init);document.addEventListener('shopify:block:load',event=>init(event.target.matches('[data-lks-root]')?event.target:event.target.querySelector('[data-lks-root]')))} )();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucia-kitchen-portal"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (!root || root.dataset.lkpReady === 'true') return;
      root.dataset.lkpReady = 'true';
      const video = root.querySelector('video');
      const toggle = root.querySelector('[data-lkp-toggle]');
      const layout = root.querySelector('.lkp-layout');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!video || !toggle) return;
      let visible = false;
      let manualPause = false;
      const sync = () => { const playing = !video.paused; toggle.classList.toggle('is-playing',playing); toggle.setAttribute('aria-label',playing ? 'Pause kitchen video' : 'Play kitchen video'); };
      const tryPlay = () => { if (!visible || reduced || manualPause) return; video.play().then(sync).catch(sync); };
      toggle.addEventListener('click',() => { if (video.paused) { manualPause=false; video.play().then(sync).catch(sync); } else { manualPause=true; video.pause(); sync(); } });
      video.addEventListener('play',sync); video.addEventListener('pause',sync);
      new IntersectionObserver(([entry]) => { visible=entry.isIntersecting; if (visible) tryPlay(); else { video.pause(); sync(); } },{threshold:.38}).observe(root);
      root.querySelectorAll('.lkp-card').forEach(card => { card.addEventListener('pointerenter',() => layout.classList.add('is-card-active')); card.addEventListener('pointerleave',() => layout.classList.remove('is-card-active')); card.addEventListener('focus',() => layout.classList.add('is-card-active')); card.addEventListener('blur',() => layout.classList.remove('is-card-active')); });
      sync();
    };
    document.querySelectorAll('[data-lkp-root]').forEach(init);
    document.addEventListener('shopify:section:load',(event) => event.target.querySelectorAll('[data-lkp-root]').forEach(init));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucia-living-room-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.llrReady === 'true' || root.dataset.designMode !== 'true') return;
      root.dataset.llrReady = 'true';
      const scene = root.querySelector('.llr-scene');
      const output = root.querySelector('.llr-coordinates');
      root.querySelectorAll('[data-llr-hotspot]').forEach((hotspot) => {
        hotspot.addEventListener('click', (event) => {
          if (hotspot.dataset.dragged === 'true') event.preventDefault();
        });
        hotspot.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          hotspot.dataset.dragging = 'true';
          hotspot.dataset.dragged = 'false';
          hotspot.setPointerCapture(event.pointerId);
        });
        hotspot.addEventListener('pointermove', (event) => {
          if (hotspot.dataset.dragging !== 'true') return;
          const rect = scene.getBoundingClientRect();
          const x = Math.max(2, Math.min(98, (event.clientX - rect.left) / rect.width * 100));
          const y = Math.max(2, Math.min(98, (event.clientY - rect.top) / rect.height * 100));
          hotspot.dataset.dragged = 'true';
          hotspot.style.setProperty('--llr-x', `${x.toFixed(1)}%`);
          hotspot.style.setProperty('--llr-y', `${y.toFixed(1)}%`);
          if (output) {
            output.hidden = false;
            output.textContent = `Hotspot ${hotspot.dataset.llrHotspot}: X ${x.toFixed(1)}% / Y ${y.toFixed(1)}%`;
          }
        });
        hotspot.addEventListener('pointerup', () => {
          hotspot.dataset.dragging = 'false';
          if (output) window.setTimeout(() => { output.hidden = true; }, 1800);
        });
      });
    };
    document.querySelectorAll('.llr-root').forEach(init);
    document.addEventListener('shopify:section:load', () => document.querySelectorAll('.llr-root').forEach(init));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucia-outdoor-vacation-finale"] && !Shopify.designMode) return;
  try {
    (()=>{const init=root=>{if(!root||root.dataset.ofvReady==='true')return;root.dataset.ofvReady='true';const slider=root.querySelector('[data-ofv-slider]'),slides=[...root.querySelectorAll('[data-ofv-slide]')],dots=[...root.querySelectorAll('[data-ofv-dot]')],accordion=root.querySelector('[data-ofv-accordion]'),journey=root.querySelector('[data-ofv-finale-journey]'),finale=journey?.querySelector('.ofv-finale'),reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;let index=0,timer,ticking=false;const show=i=>{index=i;slides.forEach((slide,n)=>slide.classList.toggle('is-active',n===i));dots.forEach((dot,n)=>dot.classList.toggle('is-active',n===i))},play=()=>{if(reduced||slides.length<2)return;clearInterval(timer);timer=setInterval(()=>show((index+1)%slides.length),Number(slider.dataset.interval)||5000)};dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.ofvDot));play()}));accordion?.querySelectorAll('.ofv-scene').forEach(scene=>{const activate=event=>{if(innerWidth>=750)return;if(!scene.classList.contains('is-active'))event.preventDefault();accordion.querySelectorAll('.ofv-scene').forEach(item=>item.classList.toggle('is-active',item===scene))};scene.addEventListener('pointerdown',activate,{capture:true});scene.addEventListener('click',activate)});const update=()=>{if(journey&&finale&&!reduced){const rect=journey.getBoundingClientRect(),range=Math.max(1,journey.offsetHeight-innerHeight),p=Math.max(0,Math.min(1,-rect.top/range));finale.style.setProperty('--ofv-progress',p.toFixed(3))}ticking=false};addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}},{passive:true});show(0);play();update()};document.querySelectorAll('[data-ofv-root]').forEach(init);document.addEventListener('shopify:block:load',event=>init(event.target.matches('[data-ofv-root]')?event.target:event.target.querySelector('[data-ofv-root]')))} )();
  } catch(e) { console.error(e); }
})();

})();
